import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { agreementTypeToProperCaseMapping } from '../../../../utils/funds/funds-utility';
import FundingReviewPage from '../../../Shared/FundingReviewPage/FundingReviewPage';
import { dispatchPageLoad } from '../../../../redux/utils/analytics-helper';

function ReviewTransfer() {
  useEffect(() => {
    dispatchPageLoad('Review Details');
  }, []);
  const fundingTracking = useSelector(
    (state) =>
      state.fundingTrackingData?.payload?.onboardingDataStore
        ?.onboardingDatastoreTransfer
  );
  const fundingTrackingData = useSelector(
    (state) => state?.fundingTrackingData
  );
  let ownerName =
    fundingTrackingData?.store?.userAccountFundingData?.agreementParties[0]
      ?.fullName;
  if (
    fundingTrackingData?.store?.normalizedAccountType.toUpperCase() ===
      agreementTypeToProperCaseMapping.JOINT_TENANT.toUpperCase() &&
    fundingTrackingData?.store?.userAccountFundingData?.agreementParties[1]
  ) {
    ownerName = `${ownerName} , ${fundingTrackingData?.store?.userAccountFundingData?.agreementParties[1]?.fullName}`;
  }
  const transferToAccNum = fundingTrackingData?.store?.AccountAgreementNumber;

  return (
    <div>
      <FundingReviewPage
        transferFromFirmName={fundingTracking?.externalFinancialInstituteName}
        transferFromAccountType={
          fundingTrackingData?.store?.normalizedAccountType
        }
        transferFromAccountNumber={
          fundingTracking?.externalFinancialInstitutionNumber
        }
        transferFromAccountOwner={ownerName}
        transferTofirmName={
          fundingTracking?.transferToFirmName || 'T.Rowe Price'
        }
        transferToAccountType={
          fundingTrackingData?.store?.normalizedAccountType
        }
        transferToAccountNumber={transferToAccNum}
        transferCD={fundingTracking?.transferCertificateOfDeposit}
        transferCDTimeFrame={
          fundingTracking?.certificateOfDepositLiquidationTimeFrame
        }
        transferCDCashAssets={fundingTracking?.cashDollarValue || ''}
        transferAmountInstructions={
          fundingTracking?.transferCertificateOfDeposit
            ? fundingTracking?.certificateOfDepositTransferType
            : fundingTracking?.onboardingTransferType
        }
        uponMaturity={fundingTracking?.certificateOfDepositMaturityDate || ''}
        transferPartialSecurities={fundingTracking?.transferSecurityAsset}
        transferPartialCashAssets={
          fundingTracking?.transferCashAsset
            ? fundingTracking?.cashDollarValue
            : false
        }
        transferPartialSecurityDetails={
          fundingTracking?.transferSecurityAsset
            ? [...fundingTracking?.onboardingTransferSecurityDetail]
            : false
        }
      />
    </div>
  );
}

export default ReviewTransfer;
